"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadFailureSchema = exports.DownloadFailureReason = exports.StoredDownloadResultSchema = exports.DownloadSummarySchema = exports.HtmlPageSummarySchema = exports.GingersnapTransportName = exports.FileType = void 0;
const zod_1 = require("zod");
const scrape_link_candidates_contract_1 = require("../workflow-contracts/Gingersnap/scrape-link-candidates.contract");
var FileType;
(function (FileType) {
    FileType["Board"] = "board";
    FileType["Schematic"] = "schematic";
})(FileType || (exports.FileType = FileType = {}));
var GingersnapTransportName;
(function (GingersnapTransportName) {
    GingersnapTransportName["Http"] = "http";
    GingersnapTransportName["Temporal"] = "temporal";
})(GingersnapTransportName || (exports.GingersnapTransportName = GingersnapTransportName = {}));
exports.HtmlPageSummarySchema = zod_1.default.object({
    finalUrl: zod_1.default.string(),
    title: zod_1.default.string(),
    links: zod_1.default.array(scrape_link_candidates_contract_1.LinkCandidateSchema),
});
exports.DownloadSummarySchema = zod_1.default.object({
    statusCode: zod_1.default.number(),
    fileName: zod_1.default.string().optional(),
    size: zod_1.default.number(),
    message: zod_1.default.string().optional(),
});
exports.StoredDownloadResultSchema = exports.DownloadSummarySchema.extend({
    location: zod_1.default.string(),
});
var DownloadFailureReason;
(function (DownloadFailureReason) {
    DownloadFailureReason["UpstreamStatus"] = "upstream_status";
    DownloadFailureReason["HtmlPage"] = "html_page";
    DownloadFailureReason["NotAPdf"] = "not_a_pdf";
    DownloadFailureReason["ConnectionFailed"] = "connection_failed";
})(DownloadFailureReason || (exports.DownloadFailureReason = DownloadFailureReason = {}));
exports.DownloadFailureSchema = zod_1.default.object({
    reason: zod_1.default.nativeEnum(DownloadFailureReason),
    statusCode: zod_1.default.number(),
    message: zod_1.default.string(),
    page: exports.HtmlPageSummarySchema.optional(),
    fileName: zod_1.default.string().optional(),
});
//# sourceMappingURL=Gingersnap.js.map